import * as Yup from 'yup'

export const initialValues: FormValuesType = {
  dueDate: '',
  dueTime: '',
  followUpTaskTypeId: undefined,
  notes: '',
}

export const formSchema = Yup.object().shape({
  followUpTaskTypeId: Yup.string().required('Please select Task Type'),
  dueDate: Yup.string().required('Please select due date'),
  notes: Yup.string().when('followUpTaskTypeId', {
    is: (followUpTaskTypeId) => followUpTaskTypeId === 4,
    then: () => Yup.string().required('Please add some notes'),
  }),
})

export interface FormValuesType {
  dueDate: string | Date
  dueTime: string | Date
  followUpTaskTypeId?: number
  notes?: string
}
